module.exports = __webpack_public_path__ + "img/dice-4.55824d57.svg";